import React from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import { useSelector } from 'react-redux';

const Accordion3 = props => {
  const contactPersonData = useSelector(state => state.contact);
  return (
    <div className={styles.accordionDetails}>
      {console.log(contactPersonData)}
      {/* Contact details */}
      <h3 className={`${styles.sectionTitle} ${styles.noBorder}`}>Contact details</h3>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>First name</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {contactPersonData?.firstname}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Last name</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {contactPersonData?.lastname}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Phone</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {contactPersonData?.contactNumber}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Email</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {contactPersonData?.emailAddress}
        </div>
      </div>
      <div className={`row ${styles.row}`}>
        <div className={`col-md-4 ${styles.label}`}>Official role</div>
        <div className={`col-md-8 ${styles.value}`} translate="no">
          {contactPersonData?.hasOfficialRoleDetails?.label}
        </div>
      </div>
      {contactPersonData?.hasOfficialRoleDetails?.label === 'Yes' ? (
        <div className={`row ${styles.row}`}>
          <div className={`col-md-4 ${styles.label}`}>Role type</div>
          <div className={`col-md-8 ${styles.value}`} translate="no">
            {contactPersonData?.contactOfficialRole?.label}
          </div>
        </div>
      ) : null}
      {contactPersonData?.relationshipType?.label ? (
        <div className={`row ${styles.row}`}>
          <div className={`col-md-4 ${styles.label}`}>Relationship</div>
          <div className={`col-md-8 ${styles.value}`} translate="no">
            {contactPersonData?.relationshipType?.label}
          </div>
        </div>
      ) : null}
      {contactPersonData?.hasOfficialRoleDetails?.label === 'No' ? (
        <div className={`row ${styles.row}`}>
          <div className={`col-md-4 ${styles.label}`}>Details of person with an official role?</div>
          <div className={`col-md-8 ${styles.value}`} translate="no">
            {contactPersonData?.officialPersonDetailsAvailable?.label}
          </div>
        </div>
      ) : null}
      <a
        tabIndex="0"
        href="javascript:void(0)"
        onKeyPress={event => {
          if (event.key === 'Enter') {
            props.history.push('/contact-details?id=1');
          }
        }}
        className={styles.editLink}
        onClick={() => {
          props.history.push('/contact-details?id=1');
        }}
      >
        Edit Notifier details
      </a>

      {/* Person with an official role */}
      {contactPersonData?.officialPersonDetailsAvailable?.label === 'Yes' ? (
        <div>
          <h3 className={styles.sectionTitle}>Person with an official role</h3>
          <div className={`row ${styles.row}`}>
            <div className={`col-md-4 ${styles.label}`}>First name</div>
            <div className={`col-md-8 ${styles.value}`} translate="no">
              {contactPersonData?.officialRoleFirstName}
            </div>
          </div>
          <div className={`row ${styles.row}`}>
            <div className={`col-md-4 ${styles.label}`}>Last name</div>
            <div className={`col-md-8 ${styles.value}`} translate="no">
              {contactPersonData?.officialRoleLastName}
            </div>
          </div>
          <div className={`row ${styles.row}`}>
            <div className={`col-md-4 ${styles.label}`}>Phone</div>
            <div className={`col-md-8 ${styles.value}`} translate="no">
              {contactPersonData?.officialRoleContactNumber}
            </div>
          </div>
          <div className={`row ${styles.row}`}>
            <div className={`col-md-4 ${styles.label}`}>Email</div>
            <div className={`col-md-8 ${styles.value}`} translate="no">
              {contactPersonData?.officialRoleEmailAddress}
            </div>
          </div>
          <div className={`row ${styles.row}`}>
            <div className={`col-md-4 ${styles.label}`}>Role</div>
            <div className={`col-md-8 ${styles.value}`} translate="no">
              {contactPersonData?.officialRoleType?.label}
            </div>
          </div>
        </div>
      ) : null}
      {contactPersonData?.officialPersonDetailsAvailable?.label === 'Yes' ? (
        <a
          tabIndex="0"
          href="javascript:void(0)"
          onKeyPress={event => {
            if (event.key === 'Enter') {
              props.history.push('/contact-details?id=4');
            }
          }}
          className={styles.editLink}
          onClick={() => {
            props.history.push('/contact-details?id=4');
          }}
        >
          Edit details
        </a>
      ) : null}
    </div>
  );
};

export default Accordion3;
